export default {
  name: "XcpCustomerService",
  computed: {
    key: function key() {
      return this.$route.fullPath;
    }
  }
};